import { useQuery } from '@tanstack/react-query';
import { ConversationSummary } from 'src/secret-menu/conversation-debugger/types';

export const useConversationSummaries = (userId: string | null, tenantName: string | null) => {
  const { data, isLoading, isError } = useQuery<ConversationSummary[]>({
    queryKey: ['admin', 'conversations', 'by-user', userId, { tenantName }],
    enabled: !!userId && !!tenantName,
  });

  return { conversations: data, isLoading, isError };
};
